module.exports = __webpack_public_path__ + "img/lotery-rewards-1.08e22d29.webp";